import { render, staticRenderFns } from "./shortlistPage.vue?vue&type=template&id=438053b6&scoped=true"
import script from "./shortlistPage.vue?vue&type=script&lang=js"
export * from "./shortlistPage.vue?vue&type=script&lang=js"
import style0 from "./shortlistPage.vue?vue&type=style&index=0&id=438053b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438053b6",
  null
  
)

export default component.exports